<template>
  <div class="business-detailObj-main detail-main">
    <div class="detail-container">
      <div class="detail-header">
        <div class="detail-tips">
          <span>
            <i class="el-icon-right" style="color:#8c98cc;"></i>帮助详情
          </span>
        </div>
        <div class="returnBack">
          <el-button size="mini" class="returnBackBtn" @click="returnBack">返回列表</el-button>
        </div>
      </div>
      <div class="detail-divider"></div>
      <div class="detail-box">
        <div class="detail-title">{{detailObj.Title}}</div>
        <div class="detail-date">{{detailObj.PublishTime}}</div>
        <div class="detail-content" v-html="detailObj.Contents"></div>
      </div>
      <div class="detail-footer">
        <!-- <div>
          <el-button size="medium" class="returnBackBtn" @click="prev()">
            <i class="el-icon-back" >上一篇</i>
          </el-button>
        </div>
        <div>
          <el-button size="medium" class="returnBackBtn" @click="next()">
            下一篇
            <i class="el-icon-right"></i>
          </el-button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      detailObj: {},
      recommendList: []
    };
  },
  created() {
    this.detailObj = this.$util.getLocalStorage("newsDetail");
  },
  mounted() {},
  watch: {},
  methods: {
    returnBack() {
      this.$router.back();
    }
  }
};
</script>
<style lang="less" scoped>
.detail-main {
  height: 100%;
  display: flex;
}
.detail-container {
  margin: 0 auto;
  width: 1200px;
}
.detail-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0px 10px 0px;
}
.detail-tips {
  font-size: 22px;
  font-weight: bold;
}
.returnBack {
  right: 0px;
}
.returnBackBtn {
  border: 1px solid #ddd;
  border-radius: 20px;
}
.detail-divider {
  border-bottom: 1px solid #dcdfe6;
}
.detail-box {
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
}
.detail-title {
  font-size: 30px;
  font-weight: 800;
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
}
.detail-date {
  margin-bottom: 20px;
}
.detail-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 100px;
}
</style>